import * as yup from '@if/core/yup'
import { useMemo } from 'react'

export function usePromoCodeYupValidator() {
  return useMemo(
    () =>
      yup
        .string()
        .matches(/^[a-zA-Z0-9]+$/)
        .nullable()
        .default(null)
        .emptyToNull(),
    [],
  )
}

function buildWorksheetSchema(availableCredit: number, amountRequested: number, term: number) {
  return yup.object({
    merchantPaymentPlanId: yup.string().nullable().default(null),
    amountRequested: yup.double().required().default(amountRequested).min(500).max(availableCredit),
    term: yup.integer().required().default(term),
    firstPaymentOn: yup.string().validDate().required(),
    includeInsurance: yup.boolean().required(),
  })
}
export function useWorksheetSchema(availableCredit: number, amountRequested: number, term: number) {
  return useMemo(
    () => buildWorksheetSchema(availableCredit, amountRequested, term),
    [availableCredit, amountRequested, term],
  )
}

export type WorksheetForm = yup.InferType<ReturnType<typeof buildWorksheetSchema>>
